/**
 * Price Decimals Fix
 * Removes ",00" and ".00" from visible price strings across the entire site.
 * Necessary because Shopify Markets converts EUR -> USD with default en-US format
 * which always shows trailing zeros, bypassing the shop's moneyFormat setting.
 *
 * Strategy: walk through all text nodes after DOM is ready, then watch with
 * MutationObserver for dynamic updates (cart drawer, sticky ATC, etc.)
 */
(function () {
  'use strict';

  // Regex matches: optional space + decimal separator + "00" at the boundary of a number
  // Examples cleaned: $406.00, 406,00€, €261.80 (NOT touched), 406.00 USD, $1,234.00
  // Match ONLY when followed by non-digit (currency symbol, space, end of string)
  const DECIMAL_REGEX = /([0-9])([.,])00(?=[^\d]|$)/g;

  function cleanText(text) {
    if (!text || text.indexOf('00') === -1) return text;
    return text.replace(DECIMAL_REGEX, '$1');
  }

  function walkAndClean(root) {
    if (!root) return;
    // Skip script/style/textarea/input
    const walker = document.createTreeWalker(
      root,
      NodeFilter.SHOW_TEXT,
      {
        acceptNode: function (node) {
          const parent = node.parentNode;
          if (!parent) return NodeFilter.FILTER_REJECT;
          const tag = parent.nodeName;
          if (tag === 'SCRIPT' || tag === 'STYLE' || tag === 'TEXTAREA' || tag === 'INPUT') {
            return NodeFilter.FILTER_REJECT;
          }
          return NodeFilter.FILTER_ACCEPT;
        }
      }
    );

    const nodesToUpdate = [];
    let n;
    while ((n = walker.nextNode())) {
      const orig = n.nodeValue;
      const cleaned = cleanText(orig);
      if (cleaned !== orig) nodesToUpdate.push({ node: n, value: cleaned });
    }
    nodesToUpdate.forEach(function (item) {
      item.node.nodeValue = item.value;
    });
  }

  // Initial clean on DOM ready
  function init() {
    walkAndClean(document.body);

    // Observe future changes (cart drawer updates, AJAX, etc.)
    const observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) walkAndClean(node);
          else if (node.nodeType === 3) {
            const cleaned = cleanText(node.nodeValue);
            if (cleaned !== node.nodeValue) node.nodeValue = cleaned;
          }
        });
        if (mutation.type === 'characterData' && mutation.target.nodeType === 3) {
          const cleaned = cleanText(mutation.target.nodeValue);
          if (cleaned !== mutation.target.nodeValue) mutation.target.nodeValue = cleaned;
        }
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
